module.exports = __webpack_public_path__ + "img/img-03.a8de0a11.jpg";